import React, { Component } from 'react';
import { FormGroupMaterial } from '../externaljs/FormGroupMaterial';

class ActivateDriverAccount extends Component {
    state = {}
    render() {
        return (
            <section class="login-register-bg" style={{ background: "url('assets/images/CreatePassword.png') no-repeat; background-attachment: fixed;background-size: cover;" }}>
                <div class="login-register-box">
                    <div class="login-register-header-box text-center">
                        <div class="m-b-40 m-t-40">
                            <a href="index.php"><img src="assets/images/logo_driver.png" alt="" /></a>
                        </div>
                        <h3>Account Activation</h3>
                        <p>Create Password</p>
                    </div>
                    <form action="dashboard.php" method="post">
                        <div class="login-box-body m-t-30">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group form-group-material">
                                        <label class="control-label">Create New Password</label>
                                        <input type="password" class="form-control" placeholder="Password" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-material">
                                        <label class="control-label">Confirm New Password</label>
                                        <input type="password" class="form-control" placeholder="Confirm Password" />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-t-40 clearfix text-center">
                                <button type="submit" class="btn btn-primary">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}

export default ActivateDriverAccount;